export enum ToastName {
  SendInviteSuccess = 'SendInviteSuccess',
  SendInvitesSuccess = 'SendInvitesSuccess',
  LinkCopied = 'LinkCopied',
  RoleUpdated = 'RoleUpdated',
  UpdateTeamDetailsSuccess = 'UpdateTeamDetailsSuccess',
  RemoveMembersSuccess = 'RemoveMembersSuccess',
  InviteResendSuccess = 'InviteResendSuccess',
  SetRoleSuccess = 'SetRoleSuccess',
  UpdateRoleSuccess = 'UpdateRoleSuccess',
  RemoveRoleSuccess = 'RemoveRoleSuccess',
  TransferOwnershipLinkCopied = 'TransferOwnershipLinkCopied',
  ResendTransferOwnership = 'ResendTransferOwnership',
  CancelTransferOwnership = 'CancelTransferOwnership',
  UpgradePlan = 'UpgradePlan',
}
